import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useCourseDocuments } from 'modules/documents/hooks';

import { useImportSubjectItemsFromCourse } from 'modules/subjects/components/ImportSubjectItemsFromCourse';

export default function useImportDocumentsFromCourse({ courseId, onConfirmSelection, importingDocuments }) {
  const intl = useIntl();
  const [selectedCourseId, setSelectedCourseId] = useState();

  const { documents, loading } = useCourseDocuments({
    courseId: selectedCourseId,
  });

  const { selectedCourse, courseSelectorProps, subjectItemsSelectorProps } = useImportSubjectItemsFromCourse({
    courseId,
    items: documents,
    loading,
    submitting: importingDocuments,
    title: intl.formatMessage({
      id: 'dialog.importDocuments.availableDocuments',
    }),
    confirmButtonTitle: intl.formatMessage({
      id: 'dialog.importDocuments.title',
    }),
    onConfirmSelection,
  });

  useEffect(() => {
    if (!selectedCourse?._id) return;
    setSelectedCourseId(selectedCourse?._id);
  }, [selectedCourse]);

  return {
    courseSelectorProps,
    subjectItemsSelectorProps,
  };
}
